import { render, staticRenderFns } from "./depositRec.vue?vue&type=template&id=639980b2&"
import script from "./depositRec.vue?vue&type=script&lang=js&"
export * from "./depositRec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports